const html = require('choo/html')

function Button(opt, children) {
  const {
    type = 'fill',
    color = 'grey',
    activeColor = 'green',
    active = false,
    onClick = () => console.log('button clicked'),
    onMouseDown = () => console.log('button down'),
    onMouseUp = () => console.log('button up')
  } = opt

  const classes = [
    'button',
    type,
    color,
    active ? 'active' : 'inactive'
  ]

  return html`
    <button
      class=${classes.join(' ')}
      onclick=${onClick}
      onmousedown=${onMouseDown}
      onmouseup=${onMouseUp}
      >
      ${children}
    </button>
  `
}

function Input(opt) {
  const {
    value = '',
    placeholder = 'type here',
    onChange = () => console.log('input changed'),
    onFocus = () => console.log('input focused'),
    onBlur = () => console.log('input blurred')
  } = opt

  return html`
  <input
    class="input"
    type="text"
    value=${value}
    placeholder=${placeholder}
    onchange=${onChange}
    onfocus=${onFocus}
    onblur=${onBlur}
    />
  `
}

function Wave(opt) {
  const {
    reads = [],
    slicePosition = 0,
    onClick = (e) => console.log('wave clicked', e)
  } = opt

  function WaveSlice(n) {
    return html`<div class="waveform" style="height: ${100+n}%"></div>`
  }

  return html`
    <div class="wave" onclick=${onClick}>
      ${reads.map(WaveSlice)}
      <div class="slice" style="width: ${(slicePosition*100)}%"></div>
    </div>
  `
}

module.exports = {
  Button, Input, Wave
}
